<template>
    <div class="newsletter" v-if="newsletter">
        <div class="newsletter__overlay">
            <div class="newsletter__inner" :class="{'newsletter__inner--confirm': doiError}">
                <div class="newsletter__background">
                    <v-lazy-image class="newsletter__background__image" :src="require('@/assets/img/xmas/newsletter.png')"></v-lazy-image>
                </div>
                <div class="newsletter__content">
                    <div class="newsletter__content__title text" v-translate>
                        sign_up_for_pumacom_newsletter
                    </div>
                    <div class="newsletter__divider">
                        <div class="newsletter__divider__inner"></div>
                    </div>
                    <div class="newsletter__content__note" v-translate>sign_up_to_the_newsletter</div>
                    <div v-if="doiError" class="newsletter__content__form form">
                        <div class="newsletter__content__form__doi"><translate>error_doi</translate></div>
                        <puma-button class="newsletter__content__form__button" @click="submitNewsletter" :loading="submitButtonLoading"><translate>check_confirmation</translate></puma-button>
                    </div>
                    <div class="newsletter__content__form form" v-if="!doiError">
                        <div class="form__row">
                            <div class="form__item">
                                <input @change="requiredFieldChange" type="email" class="form__field form__field--text" :placeholder="placeholders.email" v-model="formData.email" :class="{'is-error': errors.indexOf('email') >= 0, 'is-error': errors.indexOf('emailResponse') >= 0 }">
                                <div class="form__error" v-if="errors.indexOf('email') >= 0">"{{placeholders.email}}" <translate>form_field_required_newsletter</translate></div>
                                <div class="form__error" v-else-if="emailErrorResponse && errors.indexOf('emailResponse') >= 0"><translate>error_email</translate></div>
                            </div>
                        </div>
                        <!-- button -->
                        <div class="form__row">
                            <div class="form__item">
                                <puma-button class="newsletter__content__form__button" @click="submitNewsletter" :loading="submitButtonLoading" :disabled="!isFormValid && !specialOffers"><translate>sign_up_newsletter</translate></puma-button>
                                <div class="form__error" v-if="submitErrors.length > 0">
                                    <div v-for="error in submitErrors" :key="error">{{error}}</div>
                                </div>
                                <div class="form__error form__error--success" v-if="submitSuccess.length > 0">
                                    <div v-for="success in submitSuccess" :key="success">{{success}}</div>
                                </div> 
                            </div>
                        </div>
                         <div class="form__row">
                            <div class="form__field--checkbox">
                                <input type="checkbox" v-model="specialOffers" @change="requiredFieldChange">
                                <label for="special-offers" class="newsletter__content__form__label" v-translate>special_offers</label>
                            </div>
                            <div class="form__error" v-if="errors.indexOf('specialOffers') >= 0">{{placeholders.newsletter}}"</div>
                        </div>
                        <div class="newsletter__content__disclamer" v-translate>newsletter_discalmer</div>
                        
                        <div class="newsletter__content__links" :class="{'column' : $language.current === 'de'}">
                            <router-link to="/" tag="a" v-translate>back_to_pumatrac_newsletter</router-link>
                            <a :href="$gettext('terms_and_conditions_link')" target="_blank" v-translate>terms_and_conditions_newsletter</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { lockPage, unlockPage } from '../utils/locker';
    import axios from 'axios'
    import VueCookies from 'vue-cookies'
    export default {
        data() {
            return {
                newsletter: true,
                errors: [],
                submitButtonLoading: false,
                specialOffers: false,
                formData: {
                    email: '',
                },
                submitErrors: [],
                submitSuccess: [],
                doiError: false,
                emailError: false,
            }
        },
        computed: {
            placeholders() {
                return {
                    email: this.$gettext('email'),
                    newsletter: `"` + this.$gettext('placeholders_newsletter'),
                }
            },
            isFormValid() {
                let isValid = this.errors.length === 0;
                return isValid;
            },
            emailErrorResponse() {
                this.errors = [];
                if(this.emailError) {
                    this.errors.push('emailResponse');
                    return true;
                } else
                return false;
            }
        },
        mounted() {
            if(this.newsletter) {
               lockPage();
            }
            if(VueCookies.get('puma-calendar')) {
                this.newsletter = false; 
                unlockPage();
            } 
        },
        methods: {
            requiredFieldChange() {
                this.errors = []
                this.emailError = false;
                this.submitButtonLoading = false;
                if(this.formData.email === '') {
                    this.errors.push('email')
                }

                if(this.specialOffers === false) {
                    this.errors.push('specialOffers')
                }

                // if(this.emailError && this.formData.email !== '') {
                //     this.errors.push('emailResponse')
                // }
            },
            async submitNewsletter() {
                const self = this;
                this.submitButtonLoading = true;
                this.requiredFieldChange();
                if(!this.isFormValid && this.specialOffers) return;
                await axios.post('https://puma-christmas-calendar.sneakpeek.cc/emarsys-api.php', {
                    email: this.formData.email,
                    langauge: this.$language.current
                })
                .then(function (response) {
                    console.log(response.data.status);
                    if((response.data.status === 'success')) {
                        VueCookies.set('puma-calendar', 'true', '30d');
                        self.newsletter = false;
                        unlockPage();
                    } else {
                        if(response.data.errors[0] === 'email') self.emailError = true;
                        if(response.data.errors[0] === 'doi') self.doiError = true;
                    } 
                    self.submitButtonLoading = false;
                    // console.log(response.data.errors[0], 'ddd');
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            closeNewsletterClickHandler() {
                this.newsletter = false;
                unlockPage();
            }
        },
    }
</script>
<style lang="scss">
    .newsletter {
        $block: &;

        &__overlay {
            @include fillout();
            widows: 100%;
            height: 100%;
            background-color: rgba($puma-color-black, 0.6);
            z-index: 5;
            // overflow: auto;
            height: 100vh;
            overflow-y: auto;
        }

        &__inner {
            max-width: 540px;
            width: 100%;
            background-color: $puma-color-white;
            position: absolute;
            left: 50%;
            top: 65px;
            transform: translateX(-50%);
            overflow: auto;
            height: calc(100% - 200px);
            width: calc(100% - 40px);
            margin-bottom: 100px;

            @include mq(mobile-landscape) {
                // top: 110px;
                top: 100px;
                // height: auto;
                // height: calc(100% - 166px);
                height: 800px;
                width: 100%;
            }
            @include mq(desktop) {
                height: calc(100% - 166px);
            }

            @include mq(huge) {
                height: auto;
            }
            // @include mq(notebook) {
            //     height: auto;
            // }

            &--confirm {
               height: auto;
            }
        }

        &__background {
            position: relative;
            padding-bottom: 38.88%;

            &__image {
                @include fillout();
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        &__content {
            // padding: 40px 0;
            padding: 30px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0 auto;

            @include mq(mobile-landscape) {
                // padding: 40px 0;
                padding: 30px 0;
            }

            &__title {
                text-transform: uppercase;
                color: $puma-color-black;
                font-weight: bold;
                padding: 0 20px;

                @include mq(tablet) {
                    padding: 0;
                    max-width: 367px;
                }
            }

            &__form {
                // margin-top: 30px;
                width: 100%;
                padding: 0 20px;

                @include mq(tablet) {
                    padding: 0;
                    max-width: 367px;
                }

                &__button {
                    width: 100%;
                    text-align: center;
                    margin-top: 12px;
                    margin-bottom: 12px;
                }

                &__label {
                    color: $puma-color-black;
                    font-size: $puma-size-font-sm;
                }

                &__doi {
                    color: $puma-color-black;
                    // text-align: center;
                    margin-bottom: 15px;
                    font-size: $puma-size-font-sm;
                }
            }

            &__note {
                font-size: $puma-size-font-sm;
                max-width: 367px;
                color: $puma-color-black;
                margin-bottom: 15px;
                margin-top: 30px;
                padding: 0 20px;

                @include mq(tablet) {
                  padding: 0;
                }
            }

            &__disclamer {
                color: $puma-color-black;
                margin-top: 4px;
                // margin-bottom: 32px;
                margin-bottom: 15px;
                font-size: $puma-size-font-sm;
                max-width: 367px;

                a {
                    text-decoration: underline;
                }
            }

            &__links {
                display: flex;
                justify-content: center;
                padding: 0 20px;

                @include mq(tablet) {
                    padding: 0;
                    max-width: 367px;
                }

                &.column {
                    @include mq($until: tablet) {
                        padding: 0;
                        max-width: 367px;
                    }
                }

                a {
                    font-size: $puma-size-font-xs;
                    line-height: 1.83;
                    text-decoration: underline;
                    color: $puma-color-black;

                    &:first-of-type {
                        margin-right: 30px;
                    }
                }
            }
        }

        &__divider {
            width: 100%;
            margin-top: 12px;
            height: 1px;
            background: $puma-color-neutral-20;
            display: flex;
            align-items: center;
            justify-content: center;

            &__inner {
                height: 2px;
                background: $puma-color-black;
                width: calc(100% - 40px);

                @include mq(tablet) {
                    width: 100%;
                    max-width: 367px;
                }
            }
        }
    }
</style>
